import React from 'react'
import { Typography, Button, Box } from '@mui/material';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import { fetchBackgroundCheck } from '../../common/services/Services';
import '../../common/theme/Legal.scss';
import '../../common/theme/UserFlowPage.scss';

const DisclosureComponent = ({ name, email, user, refreshToken, openGlobalRestrictedBanner }) => {
  const { loaderStyle, setIsLoading } = HandleFormUtil(null, null, null);
  
  const handleDisclosure = async () => {
    setIsLoading(true);
     const { token } = await refreshToken();
    try {
      const data = await fetchBackgroundCheck(user, name, email, token);
      if (data.status === "AWAITING") {
        if (data.message === "DISCLOSURE_INCOMPLETE" || data.message === "DISCLOSURE_NEEDED") {
          window.location.href = data.data.docusignURL;
        } 
      }
    } catch (error) {
      openGlobalRestrictedBanner(error);
    }    
    setIsLoading(false);
  };

 return (
  <>
    <Typography className='eyebrow'>American Modern | Review authorization</Typography>
    <Typography className='title' variant='h4' style={{ fontWeight: 'bold' }}>Disclosure Regarding Consumer Reports</Typography>
    <Typography className='submission-para'>On behalf of American Modern Insurance Group, Inc. and it's insurers.<br />
          You answered yes to one or more of the background questions. Before we can grant access, please read and complete the Disclosure Regarding Consumer Reports (link below). 
          It authorizes American Modern Insurance Group to obtain consumer reports about you to help us decide whether to enter into an agency relationship with you and/or appoint
          you as our agent. For questions, please call 1 (800) 759-9008 option 2.</Typography>
    <Box className='continueButton'>
      <Button
        disableRipple
        onClick={handleDisclosure}
        className='button-styling continue-button'
        style={loaderStyle}
      >
        Continue to form
      </Button>
      </Box>
  </>
  );
};

export default DisclosureComponent;
